import { matchPath, useLocation } from 'react-router-dom';

const useRouteQueryParams = (route) => {
  const location = useLocation();
  const match =
    matchPath(location.pathname, {
      path: route,
      exact: true,
    }) ?? {};
  return match.params ?? {};
};

export default useRouteQueryParams;
